import React, { useState } from "react";
import "./ViewProjectTabs.css";

function ViewProjectTabs({ tabs }) {
    const [activeTab, setActiveTab] = useState(tabs[0].key);

    return (
        <div className="project-tabs">

            {/* Desktop Tabs */}
            <div className="tabs-header">
                {tabs.map(tab => (
                    <div
                        key={tab.key}
                        className={`tab-item ${activeTab === tab.key ? 'active' : ''}`}
                        onClick={() => setActiveTab(tab.key)}
                    >
                        {tab.label}
                    </div>
                ))}
            </div>

            {/* Desktop Content */}
            <div className="tabs-content">
                {tabs.map(tab => (
                    <div
                        key={tab.key}
                        className={`tab-panel ${activeTab === tab.key ? 'active' : ''}`}
                    >
                        {tab.component}
                    </div>
                ))}
            </div>

            {/* Mobile Accordion */}
            <div className="accordion">
                {tabs.map(tab => (
                    <div key={tab.key} className="accordion-item">
                        <div
                            className="accordion-header"
                            onClick={() => setActiveTab(activeTab === tab.key ? null : tab.key)}
                        >
                            {tab.label}
                        </div>

                        <div className={`accordion-body ${activeTab === tab.key ? 'open' : ''}`}>
                            {tab.component}
                        </div>
                    </div>
                ))}
            </div>

        </div>
    );
}

export default ViewProjectTabs;